import {createSlice} from "@reduxjs/toolkit";
import { toast } from "react-hot-toast";

const initialState = {
    allCategory : [],
    allSubCategory : [],
    products : [],
    loading : false,
    error : null    
}
const ProductSlice = createSlice({
    name : "product",
    initialState : initialState,
    reducers : {
        // Fetch Categories 
        setAllCategory :(state,action) =>{
        state.allCategory = [...action.payload]
        
        }
    }

})

export const {setAllCategory} = ProductSlice.actions

export default ProductSlice.reducer
